import { ColumnDef } from "@tanstack/react-table";
import { BranchCnRow } from "./api/reports";
import { DataTableColumnHeader } from "components/ui/data-table-column-header";
import { formatWeight } from "lib/utils";

export const createBranchCnColumns = (): ColumnDef<BranchCnRow>[] => [
  {
    accessorKey: "cn_number",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="CN Number" />
    ),
    cell: ({ row }) => (
      <div className="text-xs font-medium">{row.getValue("cn_number")}</div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "cn_date",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Date" />
    ),
    cell: ({ row }) => (
      <div className="text-xs">
        {new Date(row.getValue("cn_date")).toLocaleDateString("en-IN")}
      </div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "consignor",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Consignor" />
    ),
    cell: ({ row }) => (
      <div className="text-xs font-medium">{row.getValue("consignor")}</div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "consignee",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Consignee" />
    ),
    cell: ({ row }) => (
      <div className="text-xs font-medium">{row.getValue("consignee")}</div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "cn_origin",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Origin" />
    ),
    cell: ({ row }) => (
      <div className="text-xs font-medium">{row.getValue("cn_origin")}</div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "cn_destination",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Destination" />
    ),
    cell: ({ row }) => (
      <div className="text-xs font-medium">{row.getValue("cn_destination")}</div>
    ),
    enableSorting: true,
  },

  {
    accessorKey: "cn_value",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Value" />
    ),
    cell: ({ row }) => (
      <div className="text-xs">₹ {row.getValue("cn_value")}</div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: "actual_weight",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Actual Weight" />
    ),
    cell: ({ row }) => {
      const val = row.getValue("actual_weight") as number;
      return <div className="text-xs">{formatWeight(val)}</div>;
    },
    enableSorting: true,
  },

  {
    accessorKey: "charge_weight",
    header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Charge Weight" />
    ),
    cell: ({ row }) => {
        const val = row.getValue("charge_weight") as number;
        return <div className="text-xs">{formatWeight(val)}</div>;
    },
    enableSorting: true,
    },
];
